export
const
    IDM_Load       =  101,
    IDM_Save       =  102,
    IDM_Save_As    =  103,
    IDM_Save_All   =  104,
    IDM_Exit       =  105,
    IDM_Status_Off =  106,
    IDM_Status_On	 =  107,
    IDM_Status     =  108,
    IDM_Undo       =  206,
    IDM_On         =  308,
    IDM_Off        =  309,
    IDM_Background =  400,
    IDM_Table      =  405,
    IDM_Spot_Options = 406,
    IDM_Spot_Color   = 407,
    IDM_Help         = 601,
    IDM_About        = 602,
    
    IDM_NormalSize   = 650,
    
    ID_TOOLBAR       = 700,
    
    TOOLS_BMP        = 800,
    
    IDM_Sokoban      = 900,
    IDM_Spot         = 901,
    IDM_Rotms        = 902,
    IDM_Sound        = 903,
    IDM_New          = 904,
    IDM_Finish       = 905,
    
    NUMBUTTONS = 10,
    A = 12,
    B = 23,
    Asp = 7, //Spots in column
    Bsp = 15, //Spots in line
    W1 = 10,
    W2 = 33,
    W3 = 587,
    W4 = 312,
    otstup = 6,
    otstup_sp = 7,
    SpotBlockWidth = 40,
    SpotBlockHeight = 40,
    RotmsBlockWidth = 25,
    RotmsBlockHeight = 25,

    MENU_PIC = 10;
